import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; // Search Bar

let service = new services();

export default {
    name: 'Businesses',
    data () {
        return {
            user: {},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
                
                
            }
        }
    },
    methods: {
        saveDiv(divId, title) {
            //             var element = document.getElementById(divId);
            // html2pdf(element);
                        var d_divId = document.getElementById(divId);
                        var d_position = d_divId.getBoundingClientRect();
                        var HTML_Width = d_position.width; 
                        var HTML_Height = d_position.height; 
            
                        var element = document.getElementById(divId);
                        var opt = {
                            margin:      1,//[-3, 1, 2, 1],// 1,
                            filename:     title+'.pdf',
                            image:        { type: 'jpeg', quality: 0.98 },
                            html2canvas:  { scale: 2 },
                            // jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
                            jsPDF:        { unit: 'mm', format: 'letter', orientation: 'portrait' }
            
                            // margin: 0,
                            // filename: title+'.pdf',
                            // image: { type: 'png', quality: 0.7 },
                            // html2canvas: { scale: 1 },
                            // jsPDF: { unit: 'mm', format: [element.offsetWidth, element.offsetHeight], orientation: 'portrait' }
            
                        };
            
                        // New Promise-based usage:
                        html2pdf().set(opt).from(element).save();
                        //  var d_divId = document.getElementById(divId);
            
            
                        // var d_position = d_divId.getBoundingClientRect();
                        // var HTML_Width = d_position.width; console.log(HTML_Width)
                        // var HTML_Height = d_position.height; //$(divId).height();
                        // var top_left_margin = 15;
                        // var PDF_Width = HTML_Width + (top_left_margin * 2);
                        // var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
                        // var canvas_image_width = HTML_Width;
                        // var canvas_image_height = HTML_Height;
            
                        // var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
                        // console.log("ppp"+totalPDFPages)
                        // // let pdf = new jsPDF('p', 'pt', 'a4');
            
                        // html2canvas(d_divId).then(function (canvas) {
                        //     // var imgData = canvas.toDataURL("image/jpeg", 1.0);
                        //     // var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
                        //     let pdf = new jsPDF('p', 'pt', 'a4');
                        //     pdf.html(document.getElementById(divId), {
                        //         callback: function () {
                        //             var imgData = canvas.toDataURL("image/jpeg", 1.0);
                        //             // window.open(pdf.output('bloburl'));
                        //             pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);
                        //             for (var i = 1; i <= totalPDFPages; i++) { 
                        //                 pdf.addPage(PDF_Width, PDF_Height);
                        //                 pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
                        //                 pdf.save(title+".pdf");
                        //             }
                        //             // pdf.save(title+".pdf");
                        //         }
                        //     });
            
                            
                        // });
            
                        // let pdf = new jsPDF('l', 'pt', 'a3');
                        // pdf.html(document.getElementById(divId), {
                        //     'width': 100, // max width of content on PDF
                        //     'height':400,
                        //     callback: function (pdf) {
                        //         pdf.save('test.pdf');
                        //     }
                        // });
            
                        // var specialElementHandlers = {
                        //     '#editor': function (element,renderer) {
                        //         return true;
                        //     }
                        // };
                        // var margin = '10px';
                        // var rw_h = `<html><head><title>${title}</title></head><body>` + document.getElementById(divId).innerHTML + `</body></html>`;
                        // var doc = new jsPDF('l', 'pt', 'a3');
                        // doc.html(document.getElementById(divId),0, 0, {
                        //     'width': 100, // max width of content on PDF
                        //     'elementHandlers': specialElementHandlers,
                        
                        // callback: function(bla){doc.save(title+'.pdf');},
                        // margin});
            
                        //////
                        // let pdf = new jsPDF('l', 'pt', 'a3');
                        // pdf.html(document.getElementById(divId), {
                        //     callback: function (pdf) {
                        //         pdf.save('test.pdf');
                        //     }
                        // });
                        ////////
            //             var pdf = new jsPDF('p','pt','a4');
            // //var source = document.getElementById('table-container').innerHTML;
            // // console.log(document.getElementById('table-container'));
            // var margins = {
            //    top: 25,
            //    bottom: 60,
            //    left: 20,
            //    width: 522
            // };
            // // all coords and widths are in jsPDF instance's declared units
            // // 'inches' in this case
            // pdf.text(20, 20, 'Hello world.');
            // pdf.addHTML(document.body, margins.top, margins.left, {}, function() {
            //    pdf.save('test.pdf');
            // });
            
            //             var pdf = new jsPDF('p', 'pt', 'letter');
            //  pdf.addHTML(document.getElementById(divId), function () {
            //      pdf.save('Test.pdf');
            //  });
                        // var doc = new jsPDF();
                        // doc.fromHTML(`<html><head><title>${title}</title></head><body>` + document.getElementById(divId).innerHTML + `</body></html>`);
                        // doc.save('div.pdf');
                    },
            
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        
        //business
        setComponent(business) {
            this.business = business;
            this.panelFlag = true;
            //set has reviewed and has rated
            let reviews = this.business.business_reviews;
            reviews.forEach(function(element) {
                if(this.user.user_id == element.review_user_id){
                    this.has_reviewed = true;
                    console.log(999+element.review_user_id)
                }
            }, this);
            let rating = this.business.business_ratings;
            rating.forEach(function(element) {
                if(this.user.user_id == element.rate_user_id){
                    this.has_rated = true;
                }
            }, this);
                  
        },

        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2, // 2 for business
                save_business: this.business.business_id, //forbusiness
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('Business Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            
            })
        },
       

        setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            }
            localStorage.removeItem("cityneeds_search_business"); //remove
            localStorage.removeItem("cityneeds_search_city"); 
            localStorage.removeItem("cityneeds_search_keywords"); 
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function(data) {
            if(data.body.status == 200) {
                //get the business
                service.getBusiness(this, data.body.data).then(data2 => {
                if(data2.body.status == 200) {
                    this.business = data2.body.data;
                    this.panelFlag = true;
                   
                }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
               
            }else if(data.body.status == 400) {
             //do something here like redirect to advertised data 
               this.search_message = "Sorry Could not get the Information of entry yet";            
            }
            })
           
        },
        
        getAllBusinessesX() {
           service.getAllBusinesses(this).then(data => {
               if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getAllBusinesses(offset,items) {
            service.getSearchBusinesses(this,offset,items).then(data => {
                if(data.body.status == 200) {
                     this.businesses = data.body.data;
                     if((data.body.data_count % this.pag_intv)){
                         this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                     }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                     this.current_page = items;
                 }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },

        getSearchBusinesses(offset,items) {
           var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
            //this.search_result = localStorage.getItem("cityneeds_search_keywords");
            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials,offset,items).then(function(data) {
                if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    if((data.body.data_count % this.pag_intv)){
                        this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                    }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                     this.current_page = items;
                }else if(data.body.status == 400) {
                    //do something here like redirect to advertised data 
                    this.search_message = "Sorry Could not get the Information of entry yet";            
                }else{
                    this.search_message = "Sorry Could not get the Information of entry yet"; 
                }
            })
        },
        


        getBusiness(business) {
           service.getBusiness(this, business).then(data => {
                if(data.body.status == 200) {
                    this.business = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                if(credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                }
                 else if(credentials.search_type == "cnpros") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                   
                }
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
        },

    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        //this.getSearchBusiness();
        // this.getAllBusinesses();
        this.getAllBusinesses(0,this.pag_intv);
     }
}


// WEBPACK FOOTER //
// ./src/components/Businesses/script.js